import React, { useState } from 'react';
import './Projects.css';
import senseVideo from '../../assets/sensecluster.mov';
import algovis from '../../assets/algovis.mov';
import aiblack from '../../assets/aiblackboard.mov';
import aicode from '../../assets/aicodeassist.mov';


const projects = [
  {
    title: 'SenseCluster',
    short: 'Semantic-based related questions identifier, Q&A platform',
    long: 'SenseCluster is a full-stack Q&A platform that detects similar questions using semantic embeddings before adding new ones. It avoids duplicates and provides instant answers using transformer models.',
    tech: 'React, FastAPI, PostgreSQL, SentenceTransformers',
    codeLink: 'https://github.com/RynThakur/SenseCluster',
    demoLink: 'https://sensecluster-demo.netlify.app',
    video: senseVideo
  },
  {
    title: 'AI Code Assist',
    short: 'VS Code extension for AI-assisted coding and local CLI tasks',
    long: 'AI Code Assist is a VS Code extension that uses OpenAI or Gemini APIs to help developers generate code, automate local terminal commands, and boost productivity inside the IDE.',
    tech: 'TypeScript, Node.js, OpenAI API',
    codeLink: 'https://github.com/yourusername/ai-code-assistant',
    demoLink: 'https://marketplace.visualstudio.com/items?itemName=yourpublisher.aicodeassist',
    video: aicode
  },
  {
    title: 'AlgoVis',
    short: 'Interactive algorithm visualizer for learning DSA',
    long: 'AlgoVis is a frontend web tool that visualizes algorithms like Dijkstra, BFS, DFS, and sorting techniques. It helps users understand how algorithms work step-by-step with animations and highlights.',
    tech: 'React, HTML5 Canvas, JavaScript',
    codeLink: 'https://github.com/RynThakur/AlgoVisualizer',
    demoLink: 'https://algodemo2.pages.dev',
    video: algovis
  },
   {
    title: 'AI Blackboard',
    short: 'AI-powered digital blackboard for smart teaching',
    long: 'AI Blackboard is an interactive digital teaching tool that allows drawing, typing, and rendering math expressions. Integrated with Gemini API to answer questions and assist during teaching sessions.',
    tech: 'React, Canvas API, Gemini API, Mantine UI',
    codeLink: 'https://github.com/RynThakur/AIcalcFD',
    demoLink: 'https://ai-blackboard-demo.netlify.app',
    video: aiblack
  },
];

const Projects = () => {
  const [selected, setSelected] = useState(null);

  const handleClose = () => {
    setSelected(null);
  };

  return (
    <section id="projects">
      <h2 className="projects-heading">PROJECTS.</h2>
      <div className="projects-container">
        {projects.map((project, idx) => (
          <div
            key={idx}
            className="project-card"
            onClick={() => setSelected(project)}
          >
            <h3>{project.title}</h3>
            <p>{project.short}</p>
            <span className="tech">{project.tech}</span>
          </div>
        ))}
      </div>

      {selected && (
        <div className="project-modal">
          <div className="modal-content">
            <button className="close-btn" onClick={handleClose}>×</button>
            <h2>{selected.title}</h2>
            <video
              src={selected.video}
              controls
              autoPlay
              loop
              className="preview-video"
            />
            <p className="project-description">{selected.long}</p>
            <p className="tech-stack">Tech Used: {selected.tech}</p>
            <div className="project-links">
              <a href={selected.codeLink} target="_blank" rel="noopener noreferrer">View Code</a>
              <a href={selected.demoLink} target="_blank" rel="noopener noreferrer">Live Demo</a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;
